import { createStyles, makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import deepmerge from "deepmerge";
import * as React from "react";
import { Link, LinkProps } from "react-router-dom";

import { RelodeTheme } from "../";
import { RelodeCSSProperties } from "../styles";

const baseStyles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            textDecoration: "none",
            display: "inline-block",
        },
        internalHighlight: {
            transition: "box-shadow 400ms cubic-bezier(0.33, 0, 0, 1)",
            boxShadow: `0 2px 0px 0px ${theme.relode.colors.internalHighlight.main}, 0 0 0 0 ${theme.relode.colors.internalHighlight.main} inset`,
            cursor: "pointer",
            "&:hover": {
                boxShadow: `0 2px 0px 0px ${theme.relode.colors.internalHighlight.main}, 0 -0.8rem 0 0 ${theme.relode.colors.internalHighlight.main} inset`,
            },
        },
        externalHighlight: {
            transition: "box-shadow 400ms cubic-bezier(0.33, 0, 0, 1)",
            boxShadow: `0 2px 0px 0px ${theme.relode.colors.externalHighlight.main}, 0 0 0 0 ${theme.relode.colors.externalHighlight.main} inset`,
            cursor: "pointer",
            "&:hover": {
                boxShadow: `0 2px 0px 0px ${theme.relode.colors.externalHighlight.main}, 0 -0.8rem 0 0 ${theme.relode.colors.externalHighlight.main} inset`,
            },
        },
    });

type RouteLinkCSSProperties =
    | "root"
    | "internalHighlight"
    | "externalHighlight";
export type RouteLinkStyles = RelodeCSSProperties<RouteLinkCSSProperties>;
const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        deepmerge(baseStyles(theme), theme.relode.controls.routeLink || {}),
    { name: "routeLink" }
);

interface RouteLinkProps extends LinkProps {
    highlightType?: "internal" | "external" | "none";
}

export const RouteLink = (props: RouteLinkProps) => {
    const classes = useStyles({});

    const { highlightType = "none", ...rest } = props;
    const rootClass = classnames({
        [classes.root]: true,
        [classes.externalHighlight]: highlightType === "external",
        [classes.internalHighlight]: highlightType === "internal",
    });
    return <Link data-cy="routeLink" {...rest} className={rootClass} />;
};
